<template>
  <v-card class="px-4" elevation="0">
    <v-divider class="grey my-2"></v-divider>
    <v-row no-gutters class="text-center subtitle-1">
      <v-col cols="12" class="font-weight-bold">
        <span>Список зданий</span>
      </v-col>
    </v-row>
    <v-divider class="grey my-2"></v-divider>
    <v-data-table
        :headers="headers"
        :items="items"
        :loading="isLoading"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.size"
        :server-items-length="count"
        :options.sync="options"
        :footer-props="{'items-per-page-options':[10,50,100]}"
        class="elevation-0 pb-2"
    >
      <template v-slot:item.name="{ item }">
        <span>{{ item.building.name }}</span>
      </template>
      <template v-slot:no-data>
        <v-btn
            color="primary"
            @click="loadData()"
        >
          Обновить
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";

export default {
  name: "GuardPostDetailBuildingList",
  props:["post"],
  mixins:[PaginatedDataMapperMixin],
  data() {
    return {
      headers: [
        {text: "Наименование", value: "name", sortable: false, align: "start", width: "80%"},
        {text: "Действия", value: "actions", sortable: false, align: "center", width: "20%"}
      ]
    }
  },
  computed: {
    ...mapGetters({
      items: "entitled/getGuardBuilding",
      count: "entitled/getGuardBuildingCount",
      isLoading: "entitled/isLoadingGuardBuilding"
    })
  },
  methods: {
    ...mapActions({
      loadGuardBuildingList: "entitled/loadGuardBuildingList"
    }),
    loadData(url = undefined) {
      this.loadGuardBuildingList({
        url: url,
        post_id: this.post.id,
        urlAppend: (url) => {
          return this.addSizeParameter(url);
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url);
        }
      })
    }
  },
  created() {
    this.loadData()
  }
}
</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
